module.exports = __webpack_public_path__ + "static/media/mr._potato_head.874a4cc2.jpg";